// GET FINANCES
export const GET_FINANCES = 'GET_FINANCES';
export const GET_FINANCES_SUCCESS = 'GET_FINANCES_SUCCESS';
export const GET_FINANCES_FAILED = 'GET_FINANCES_FAILED';

// GET FINANCE OVERVIEW
export const GET_FINANCE_OVERVIEW = 'GET_FINANCE_OVERVIEW';
export const GET_FINANCE_OVERVIEW_SUCCESS = 'GET_FINANCE_OVERVIEW_SUCCESS';
export const GET_FINANCE_OVERVIEW_FAILED = 'GET_FINANCE_OVERVIEW_FAILED';
